import React, { CSSProperties, PropsWithChildren } from 'react';
import { ProgressBar } from 'react-bootstrap';

import './index.scss';

// Estado 2 do design (.dc.html:245-246 e 409-411). Opacidade e bloqueio de cliques ficam inline,
// como no protótipo, porque mudam com o estado; posição e cor da barra ficam no index.scss.
const PENDING_CONTENT_STYLE: CSSProperties = { opacity: 0.45, pointerEvents: 'none' };
const PENDING_BAR_STYLE: CSSProperties = { height: '3px' };

export interface PendingOverlayProps {
  /** `true` no estado `pending` do `useMyStudiesListState` (troca de argumentos ou "Atualizar"). */
  pending: boolean;
}

/**
 * Envolve a lista da aba Meus Estudos e a esmaece enquanto a próxima página chega: opacidade .45,
 * cliques bloqueados e barra fina de 3 px no topo (#1992). A barra fica fora da área esmaecida,
 * na cor cheia, como no estado 2 do design.
 *
 * O bloqueio vale também para teclado e leitor de tela: a área esmaecida fica `inert` (o
 * `pointer-events: none` só barra o ponteiro; Tab + Enter ainda acionaria "Excluir" numa linha do
 * filtro anterior). Por isso filtros, "Atualizar" e paginação ficam FORA do `PendingOverlay`: um
 * botão com foco que vira `inert` perde o foco para o `body`.
 *
 * As linhas continuam montadas ao entrar e sair do pendente (o wrapper é sempre o mesmo). A região
 * fica com `aria-busy`; a barra é decorativa e sai da árvore de acessibilidade: o `ProgressBar`
 * anunciaria 100 % de um progresso que não é medido.
 */
export default function PendingOverlay({
  pending,
  children,
}: PropsWithChildren<PendingOverlayProps>) {
  return (
    <div className="my-studies-pending" aria-busy={pending} data-testid="my-studies-pending">
      {pending && (
        <ProgressBar
          now={100}
          className="my-studies-pending-bar"
          style={PENDING_BAR_STYLE}
          aria-hidden="true"
          data-testid="my-studies-pending-bar"
        />
      )}
      <div
        className="my-studies-pending-content"
        style={pending ? PENDING_CONTENT_STYLE : undefined}
        inert={pending}
        data-testid="my-studies-pending-content"
      >
        {children}
      </div>
    </div>
  );
}
